import React from 'react'
import { CustomerAgencyAuditSnapshotV1, IAuditEventData } from '../../../api'
import { useDetailStyles } from './useDetailStyles'
import { Box } from 'cs-kevlar-react'
import { UnavailableDetails } from './UnavailableDetails'
import { resolveSnapshots } from './utils'
import { DetailField } from './DetailField'

interface CustomerAgencyDetailsProps {
  eventData: IAuditEventData
}

export const CustomerAgencyDetails: React.FunctionComponent<CustomerAgencyDetailsProps> = ({
  eventData,
}) => {
  const classes = useDetailStyles()
  const [originalSnapshot, updatedSnapshot] = resolveSnapshots<
    CustomerAgencyAuditSnapshotV1
  >(eventData, nameof<CustomerAgencyAuditSnapshotV1>())
  const showDiff = !!originalSnapshot && !!updatedSnapshot

  if (!updatedSnapshot && !originalSnapshot) return <UnavailableDetails />

  return (
    <React.Fragment>
      <Box className={classes.fieldsContainer}>
        <DetailField
          label="Name"
          showDiff={showDiff}
          original={originalSnapshot?.name}
          updated={updatedSnapshot?.name}
        />

        <DetailField
          label="Product Line"
          showDiff={showDiff}
          original={originalSnapshot?.productLine}
          updated={updatedSnapshot?.productLine}
        />

        <DetailField
          label="Connector Type"
          showDiff={showDiff}
          original={originalSnapshot?.connectorType}
          updated={updatedSnapshot?.connectorType}
        />

        <DetailField
          label="Notes"
          showDiff={showDiff}
          original={originalSnapshot?.notes}
          updated={updatedSnapshot?.notes}
        />

        <DetailField
          label="Database Shard"
          showDiff={showDiff}
          original={originalSnapshot?.databaseShardId?.toString()}
          updated={updatedSnapshot?.databaseShardId?.toString()}
        />
      </Box>
    </React.Fragment>
  )
}
